<div *ngIf="lightLayout" cdkDrag>
    <div class="se-suggestion-selector-overlay-toolbar" cdkDragHandle>
        <mat-icon
            title="{{ 'se-ui-text-editor_cmd_close_tooltip' | translate }}"
            class="se-suggestion-selector-close-button"
            (click)="onSelectorCloseCommand()"
            >close</mat-icon
        >
    </div>
    <div class="se-suggestion-selector-overlay">
        <se-suggestion-selector
            [currentFilter]="currentFilter"
            [suggestions]="filteredItems()"
            (selectedSuggestion)="onSelectorSuggestionSelected($event)"
            (preSelectedSuggestionEmitter)="onPreselectedSuggestion($event)"
            (closeCommand)="onSelectorCloseCommand()"
        >
        </se-suggestion-selector>
    </div>
</div>

<div cdkDrag *ngIf="!lightLayout" class="overlay-expander-size">
    <div cdkDragHandle>
        <div class="se-suggestion-selector-overlay-toolbar"
             [ngClass]="{ 'se-suggestion-selector-overlay-toolbar_edit': _editingView }">
            <button *ngIf="!_editingView" mat-button (click)="_onClickAddNew()">
                <mat-icon aria-hidden="false"
                          [matTooltip]="'DefaultText_AddDefautText' | translate"
                          matTooltipPosition="below"
                          matTooltipShowDelay="0">playlist_add</mat-icon>
            </button>
            <div *ngIf="!_editingView" class="se-suggestion-selector-overlay-toolbar-filter">
                <mat-form-field class="se-form-field" appearance="outline">
                    <mat-label class="se-suggestion-selector-label-filter" >{{ "FilterText" | translate }}</mat-label>
                    <input matInput class="se-trim se-form-field-input" type="text" (input)="setFilter($event)" />
                </mat-form-field>
            </div>
            <button mat-button
                    title="{{ 'se-ui-text-editor_cmd_close_tooltip' | translate }}"
                    (click)="onSelectorCloseCommand()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </button>
        </div>
        
    </div>

    <div
        [ngClass]="
            _editingView ? 'se-suggestion-selector-overlay__expander' : 'se-suggestion-selector-overlay__expander-edit'
        "
    >
        <se-ui-default-text
            [_addingNewText]="_addNewSuggestion"
            [currentFilter]="currentFilter"
            [suggestions]="filteredItems()"
            [defaultTextName]="defaultTextName"
            [newTextsGroup]="_newTextsGroup"
            (selectedSuggestion)="onSelectorSuggestionSelected($event)"
            (preSelectedSuggestionEmitter)="onPreselectedSuggestion($event)"
            (closeCommand)="onSelectorCloseCommand()"
            (undoCommand)="onSelectorUndoCommand()"
            (isEditing)="onEditing($event)"
            (updateSuggestions)="updateSuggestions($event)"
        >
        </se-ui-default-text>
    </div>
</div>
